import { css } from 'styled-components';

export const SortableCategoriesStyled = css`
  .ant-collapse-item.sortable-categories > .ant-collapse-header {
    display: flex;
    align-items: center;

    .anticon-menu {
      margin-right: 12px;
    }
  }
`;
